export enum TemplateUsage {
  AwesomeDocs = 'AWESOME_DOCS',
  DocMerge = 'DOC_MERGE',
}
